module.exports = ".cast-widget {\n  width: auto;\n  text-align: center;\n  background: rgba(0, 0, 0, 0.9);\n  padding: 5px 15px;\n  opacity: 0;\n  transition: opacity 0.25s ease-in-out;\n  cursor: pointer; }\n  .cast-widget .vg-icon-cast.connected {\n    display: inline-block;\n    vertical-align: middle;\n    margin-top: -4px;\n    font-size: 22px; }\n  .cast-widget.active {\n    opacity: 1; }\n    .cast-widget.active:hover {\n      opacity: 1 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/chromcast-widget/cast-widget.style.scss
// module id = 835
// module chunks = 2